<template>
  <div class="content">
    <div class="item" @scroll="bindScroll">
      <BmiComponent
        v-if="data.title == 'BMI值'"
        :data="data"
        :ref="data.field"
      />
      <WeightComponent
        v-else-if="data.title == '体重'"
        :data="data"
        :ref="data.field"
      />
      <CommonComponent v-else :data="data" :ref="data.field" />
    </div>
    <!-- 按钮 -->
    <div class="btn-content" @click="bindSetRecord" v-if="isApp">
      <span class="iconfont icon-jiahao"></span
      ><span>记录{{ data.title }}</span>
    </div>
  </div>
</template>
<script>
import LineCanvas from '../line-canvas/line-canvas.vue'
import BmiComponent from './bmi.vue'
import WeightComponent from './weight.vue'
import CommonComponent from './common-item.vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: {
    LineCanvas,
    BmiComponent,
    WeightComponent,
    CommonComponent
  },
  data() {
    return {
      bmi: 15,
      curNav: 0,
      navData: [
        {
          title: '近7次',
          index: 0,
          data: null
        },
        {
          title: '月',
          index: 1,
          data: null
        }
      ],
      isApp: false
    }
  },
  created() {
    this.isApp = this.$http._isApp()
  },
  methods: {
    bindScroll(e) {
      let target = e.target
      let scrollHeight = target.scrollHeight
      let scrollTop = target.scrollTop
      let offsetHeight = target.offsetHeight
      let isBottom =
        scrollHeight - offsetHeight - scrollTop <= 100 ? true : false
      if (isBottom) {
        this.getHistory()
      }
    },
    //到底后请求历史记录
    getHistory() {
      let type = this.data.field
      this.$refs[type].getHistory && this.$refs[type].getHistory()
    },
    changeNav(index) {
      this.curNav = index
    },
    bindSetRecord() {
      let rulerOptions = Object.assign(
        {
          title: this.data.title,
          unit: this.data.unit
        },
        this.data.rulerOptions
      )
      let lastValue = this.getLastValue()
      console.log(lastValue)
      if (lastValue !== undefined) {
        rulerOptions.defaultNum = +lastValue
      }
      this.$emit('addRecord', rulerOptions, this)
    },
    getLastValue() {
      let type = this.data.field
      if (type == 'bmi') {
        return this.$refs[type].bmi || undefined
      } else {
        let list = this.$refs[type].historyList
        return list?.length ? +list[0].data_value : undefined
      }
    },
    bindConfirm(value) {
      this.addRecord(value)
    },
    addRecord(value) {
      let type = this.data.field
      this.$refs[type].updateRecord && this.$refs[type].updateRecord(value)
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  position: relative;
  height: 100%;
}

.item {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  background-color: #4a3d6b;

  .tips {
    margin-top: 20px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;

    .tip-line {
      width: 13px;
      height: 1px;
      background-color: rgba(255, 255, 255, 0.5);
    }

    .text {
      margin: 0px 12px;
    }
  }
}

.btn-content {
  backface-visibility: visible;
  position: absolute;
  left: 50%;
  bottom: 23px;
  transform: translate(-50%, 0%);
  width: 334px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #6236ff;
  box-shadow: 0px 3px 9px 0px rgba(160, 120, 251, 0.3);
  border-radius: 12px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
  z-index: 10;
  text-shadow: 0px 3px 9px rgba(160, 120, 251, 0.3);

  .iconfont {
    margin-right: 10px;
  }
}
</style>
